module.exports = __webpack_public_path__ + "static/3-43120f501f29de0df35521bba63cccd4.jpg";